import useBreakpoint from '@/hooks/useBreakpoint';

import CabecalhoHomeMobileFallback from '../Designs/Mobile/fallback/index';
import CabecalhoHomeDesktopFallback from '../Designs/Desktop/fallback/index';
import { HeaderProps } from '@/components/atoms/Header';

export default function CabecalhoHomeFallback(props: HeaderProps) {
  const { breakpoint } = useBreakpoint();

  return breakpoint === 'mobile' ? (
    <CabecalhoHomeMobileFallback {...props} />
  ) : (
    <CabecalhoHomeDesktopFallback {...props} />
  );
}
